exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  width: 100%;\n  text-align: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  max-width: 220px;\n  height: 100%;\n  padding: 0 10px;\n  z-index: 9995; }\n\n.mat-list-item {\n  background: transparent;\n  padding: 20px 10px; }\n  .mat-list-item a {\n    transition: color .5s ease;\n    cursor: pointer;\n    font-size: 1.2em; }\n    .mat-list-item a:hover {\n      color: #ff872D; }\n    .mat-list-item a.activeButton {\n      color: #ff872D; }\n\nimg.logo {\n  position: relative;\n  width: 100%;\n  z-index: 2;\n  display: block;\n  margin: 0 auto 20px; }\n\n.add-field-zone {\n  width: 200px;\n  margin: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/menu/menu.component.scss
// module id = ../../../../../src/app/components/menu/menu.component.scss
// module chunks = main